import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _orderBy from 'lodash/orderBy';
import _uniqBy from 'lodash/uniqBy';
import {
  getPatients,
  getPatient,
  createPatient,
  updatePatient,
  deletePatient,
  deleteLocalPatient,
  clearLocalPatients,
  clearLocalActivePatient
} from './actions';

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 }, source: null },
  patient: { 
    id: '',
    first_name: '',
    last_name: '',
    gender: '',
    birth_at: '',
    clinic: null, 
    mode: '', 
    trigger: '', 
    phone: '', 
    email: '', 
    source: '', 
    language: '',  
    street_address: '',
    city: '',
    state: '',
    zip: '', 
    updated_at: '' 
  },
  loading: { 
    all: false, 
    patient: false, 
    deletePatient: false 
  }
};

const  slice = createSlice({
  name: 'patients',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getPatients.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getPatients.fulfilled, (state, action) => {
        const { data: { patients, pagination }, source } = action.payload;
        
        state.loading.all = false;
        state.all =  { ...state.all, data: _uniqBy([...state.all.data, ...patients], 'id'), pagination, source };
      })
      .addCase(getPatients.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getPatient.pending, (state) => {
        state.loading.patient = true;
      })
      .addCase(getPatient.fulfilled, (state, action) => {
        const { data: { patient }, cable } = action.payload;
        const checkSource = !state.all.source || patient.source === state.all.source;
        const foundedPatient = !!_find(state.all.data, (c) => c.id === patient.id);
        const updatedPatient = { ...state.patient, ...patient };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedPatient ? _map(state.all.data, (item) => item.id === patient.id ? { ...item, ...patient } : item) : [...[patient], ...oldAllData]; 
        const pagination = foundedPatient ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.patient = false;
        if (checkSource) state.all = { ...state.all, data: _orderBy(data, ['updated_at'], ['desc']), pagination };
        if (foundedPatient && !cable) state.patient = updatedPatient;     
      })
      .addCase(getPatient.rejected, (state) => {
        state.loading.patient = false;
      })
      .addCase(createPatient.pending, (state) => {
        state.loading.patient = true;
      })
      .addCase(createPatient.fulfilled, (state, action) => {
        const { patient } = action.payload;
        const checkSource = !state.all.source || patient.source === state.all.source;
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = [...[patient], ...oldAllData];
        const pagination = { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.patient = false;
        if (checkSource) {
          state.all = { ...state.all, data, pagination };
          state.patient = patient;
        }
      })
      .addCase(createPatient.rejected, (state) => {
        state.loading.patient = false;
      })
      .addCase(updatePatient.pending, (state) => {
        state.loading.patient = true;
      })
      .addCase(updatePatient.fulfilled, (state, action) => {
        const { status, patient } = action.payload;
        const data = _map(state.all.data, (p) => p.id === patient.id ? { ...p, ...patient } : p)
        const updatedPatient = { ...state.patient, ...patient };
        
        state.loading.patient = false;
        if (status === 204) {
          state.all.data = data;
          state.patient = updatedPatient;
        }     
      })
      .addCase(updatePatient.rejected, (state) => {
        state.loading.patient = false;
      })
      .addCase(deletePatient.pending, (state) => {
        state.loading.patient = true;
        state.loading.deletePatient = true;
      })
      .addCase(deletePatient.fulfilled, (state, action) => {
        const { status, id } = action.payload;
        
        state.loading.patient = false;
        state.loading.deletePatient = false;
        if (status === 204) {
          state.all.data = _filter(state.all.data, (item) => item.id !== id);
          state.all.pagination = { ...state.all.pagination, count: state.all.pagination.count - 1, total_count: state.all.pagination.total_count - 1 };
          state.patient = initialState.patient;
        }
      })
      .addCase(deletePatient.rejected, (state) => {
        state.loading.patient = false;
        state.loading.deletePatient = false;
      })
      .addCase(deleteLocalPatient, (state, action) => {
        const id = action.payload;
        const foundedPatient = !!_find(state.all.data, (c) => c.id === id);

        if (foundedPatient) {
          state.all.data =  _filter(state.all.data, (item) => item.id !== id);
          state.all.pagination.count = state.all.pagination.count - 1;
          state.all.pagination.total_count = state.all.pagination.total_count - 1;
        }
      })
      .addCase(clearLocalPatients, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActivePatient, state => {
        state.patient = initialState.patient;
      })
  }
})

export default slice.reducer;